import React from 'react';
import ReactDOM from 'react-dom/client';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import store from './redux/store';
import { Provider } from 'react-redux';
import App from './App';

import { ClerkProvider } from '@clerk/clerk-react';
import Toast from './components/common/Toast';
import Notifications from 'react-notify-toast';
import './index.css';
import {ModalViewer} from "react-easetools";
const ErrorBoundary = React.lazy(() => import('./pages/Error/ErrorBoundary'));

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const ldClientId  = process.env.REACT_APP_LD_CLIENT_ID!;

(async () => {
  /* wait for LaunchDarkly before we render anything */
  const LDProvider = await asyncWithLDProvider({
    clientSideID: ldClientId,
    context: { kind: 'organization', key: 'anonymous' },
    options: {
      streaming: false,
      sendEvents: false,
    },
  });

  ReactDOM
    .createRoot(document.getElementById('root') as HTMLElement)
    .render(
      <LDProvider>
        <ModalViewer></ModalViewer>
        <Provider store={store}>
          <ErrorBoundary>
            {clerkPubKey && (
              <ClerkProvider
                appearance={{
                  layout: {
                    logoImageUrl: "http://localhost:3000/static/media/cp.efc18886c96d199aea1e.png",
                    logoPlacement: "inside",
                    showOptionalFields: true,
                    socialButtonsPlacement: "bottom",
                    socialButtonsVariant: "iconButton",
                  }
                }}
                publishableKey={clerkPubKey}
              >
                <App />
                <Toast />
                <Notifications />
              </ClerkProvider>
            )}
          </ErrorBoundary>
        </Provider>
      </LDProvider>
    );
})();
